// extracted by mini-css-extract-plugin
module.exports = {"table":"SyncCommonIdInsideForm__table--1ZS5F m-table-list"};